import React from 'react';

import ReactApexChart from 'react-apexcharts';

import { ICONS } from '@/constants/icons.constants';
import Icons from '@/icons';

const months = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sept',
  'Oct',
  'Nov',
  'Dec',
];

const weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

//   let categories = [];

//   // { value: 'DAILY', label: 'Daily' },
//   // { value: 'WEEKLY', label: 'Weekly' },
//   // { value: 'MONTHLY', label: 'Monthly' },
//   // { value: 'HALF_YEARLY', label: 'Half Yearly' },
//   // { value: 'START_YEAR', label: 'Start Year' },
//   // { value: 'YEARLY', label: 'Yearly' },

//   if (graphFilter === 'YEARLY') categories = months;
//   else if (graphFilter === 'START_YEAR') categories = months.slice(0, new Date().getMonth() + 1);
//   else if (graphFilter === 'HALF_YEARLY') {
//     if (new Date().getMonth() <= 5) categories = months.slice(0, 6);
//     else categories = months.slice(new Date().getMonth() - 5, new Date().getMonth() + 1);
//   } else if (graphFilter === 'MONTHLY') categories = Array.from({ length: 31 }, (_, i) => i + 1);
//   else if (graphFilter === 'WEEKLY') categories = Array.from({ length: 7 }, (_, i) => weekdays[i]);
//   else categories = Array.from({ length: 24 }, (_, i) => i);

//   // if (graphFilter === 'This Year') categories = months;
//   // else if (graphFilter === 'This 6 Months') {
//   //   if (new Date().getMonth() <= 5) categories = months.slice(0, 6);
//   //   else categories = months.slice(new Date().getMonth() - 5, new Date().getMonth() + 1);
//   // } else if (graphFilter === 'This Month') categories = Array.from({ length: 31 }, (_, i) => i + 1);
//   // else if (graphFilter === 'Last 7 days')
//   //   categories = Array.from({ length: 7 }, (_, i) => weekdays[i]);
//   // else categories = months;

//   return {
//     legend: {
//       show: false,
//     },
//     chart: {
//       // type: 'bar',
//       // height: 200,
//       id: 'apexchart-example',

//       toolbar: {
//         show: false,
//       },
//     },
//     dataLabels: {
//       enabled: false,
//       // hideOverflowingLabels: false,
//     },

//     plotOptions: {
//       bar: {
//         horizontal: false,
//         columnWidth: '55%',
//         endingShape: 'rounded',
//       },
//     },

//     // colors: ['red', 'yellow' ],

//     stroke: {
//       show: true,
//       width: 2,
//       colors: ['transparent'],
//     },
//     grid: {
//       show: false,
//     },
//     xaxis: {
//       categories: categories,
//       axisTicks: {
//         show: false,
//       },

//       tickAmount: 12,

//       labels: {
//         show: true,
//         style: {
//           // colors: [
//           //   '#71717A',
//           //   '#71717A',
//           //   '#71717A',
//           //   '#71717A',
//           //   '#71717A',
//           //   '#71717A',
//           //   '#71717A',
//           //   '#71717A',
//           //   '#71717A',
//           // ],
//           fontSize: '13px',
//           paddingRight: 15,
//           paddingLeft: 15,
//           fontFamily: 'Plus Jakarta Sans, Arial, sans-serif',
//           fontWeight: 500,
//           lineHeight: 20,
//         },
//       },
//     },

//     yaxis: {
//       tickAmount: 12,
//       labels: {
//         show: false,
//         style: {
//           colors: ['#71717A'],
//           fontSize: '12px',
//           paddingRight: 15,
//           paddingLeft: 15,
//           fontFamily: 'Plus Jakarta Sans, Arial, sans-serif',
//           fontWeight: 500,
//           lineHeight: 20,
//         },

//         // formatter: function (val: string) {
//         //   return numberWithCommas(parseInt(val));
//         // },
//       },
//     },
//     fill: {
//       // fill: linear-gradient(180deg, #0067FB -6.1%, rgba(0, 103, 251, 0.00) 100.93%);
//       // opacity: 0.1;
//       type: 'gradient',
//       gradient: {
//         shade: 'dark',
//         type: 'horizontal',
//         shadeIntensity: 0.5,
//         gradientToColors: ['#0067FB'],
//         inverseColors: true,
//         opacityFrom: 1,
//         opacityTo: 1,
//         stops: [0, 100],
//         colorStops: [
//           {
//             offset: 0,
//             color: '#0067FB',
//             opacity: 1,
//           },
//           {
//             offset: 100,
//             color: '#0067FB',
//             opacity: 1,
//           },
//         ],
//       },
//     },
//     //   tooltip: {
//     //     y: {
//     //       formatter: function (val) {
//     //         return '$ ' + val + ' thousands';
//     //       },
//     //     },
//     //   },}
//   };
// };
const options = (graphFilter: string) => {
  let categories = [];

  // { value: 'DAILY', label: 'Daily' },
  // { value: 'WEEKLY', label: 'Weekly' },
  // { value: 'MONTHLY', label: 'Monthly' },
  // { value: 'HALF_YEARLY', label: 'Half Yearly' },
  // { value: 'START_YEAR', label: 'Start Year' },
  // { value: 'YEARLY', label: 'Yearly' },

  if (graphFilter === 'YEARLY') categories = months;
  else if (graphFilter === 'START_YEAR') categories = months.slice(0, new Date().getMonth() + 1);
  else if (graphFilter === 'HALF_YEARLY') {
    if (new Date().getMonth() <= 5) categories = months.slice(0, 6);
    else categories = months.slice(new Date().getMonth() - 5, new Date().getMonth() + 1);
  } else if (graphFilter === 'MONTHLY') categories = Array.from({ length: 31 }, (_, i) => i + 1);
  else if (graphFilter === 'WEEKLY') categories = Array.from({ length: 7 }, (_, i) => weekdays[i]);
  else categories = Array.from({ length: 24 }, (_, i) => i);

  // if (graphFilter === 'This Year') categories = months;
  // else if (graphFilter === 'This 6 Months') {
  //   if (new Date().getMonth() <= 5) categories = months.slice(0, 6);
  //   else categories = months.slice(new Date().getMonth() - 5, new Date().getMonth() + 1);
  // } else if (graphFilter === 'This Month') categories = Array.from({ length: 31 }, (_, i) => i + 1);
  // else if (graphFilter === 'Last 7 days')
  //   categories = Array.from({ length: 7 }, (_, i) => weekdays[i]);
  // else categories = months;

  return {
    legend: {
      show: false,
    },
    chart: {
      // type: 'bar',
      type: 'area',
      // height: 200,
      id: 'apexchart-example',

      toolbar: {
        show: false,
      },
    },
    dataLabels: {
      enabled: false,
      // hideOverflowingLabels: false,
    },

    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '55%',
        endingShape: 'rounded',
      },
    },

    // colors: ['red', 'yellow' ],

    // stroke: {
    //   show: true,
    //   width: 2,
    //   colors: ['transparent'],
    // },
    // stroke: {
    //   curve: 'smooth',
    //   width: 3,
    //   colors: ['#0067FB'],
    // },
    stroke: {
      curve: 'smooth',
      width: 3,
      colors: ['rgba(0, 103, 251, 0.6)'], // Using RGBA for semi-transparent blue
    },

    // fill: {
    //   type: 'gradient',
    //   gradient: {
    //     shadeIntensity: 1,
    //     opacityFrom: 0.7,
    //     opacityTo: 0.3,
    //     // define multiple stops
    //     stops: [0, 90, 100],
    //     colorStops: [],
    //   },
    // },
    fill: {
      type: 'gradient',
      gradient: {
        type: 'vertical', // The gradient should be vertical, assuming the lighter color is at the bottom
        shadeIntensity: 1, // Intensity of the shade color
        opacityFrom: 0.7, // Full opacity at the start of the gradient
        opacityTo: 0.0, // Completely transparent at the end of the gradient
        stops: [0, 20, 40, 60, 80, 100], // More stops give a smoother gradient
        colorStops: [
          {
            offset: 0,
            color: '#0067FB',
            opacity: 0.09,
          },
          {
            offset: 20,
            color: '#0067FB',
            opacity: 0,
          },
          {
            offset: 40,
            color: '#0067FB',
            opacity: 0,
          },
          {
            offset: 60,
            color: '#0067FB',
            opacity: 0,
          },
          {
            offset: 80,
            color: '#0067FB',
            opacity: 0,
          },
          {
            offset: 100,
            color: '#0067FB',
            opacity: 0,
          },
        ],
      },
    },

    grid: {
      show: false,
    },
    xaxis: {
      categories: categories,
      axisTicks: {
        show: false,
      },

      tickAmount: 12,

      labels: {
        show: true,
        style: {
          // colors: [
          //   '#71717A',
          //   '#71717A',
          //   '#71717A',
          //   '#71717A',
          //   '#71717A',
          //   '#71717A',
          //   '#71717A',
          //   '#71717A',
          //   '#71717A',
          // ],
          fontSize: '13px',
          paddingRight: 15,
          paddingLeft: 15,
          fontFamily: 'Plus Jakarta Sans, Arial, sans-serif',
          fontWeight: 500,
          lineHeight: 20,
        },
      },
    },

    yaxis: {
      tickAmount: 12,
      labels: {
        show: false,
        style: {
          colors: ['#71717A'],
          fontSize: '12px',
          paddingRight: 15,
          paddingLeft: 15,
          fontFamily: 'Plus Jakarta Sans, Arial, sans-serif',
          fontWeight: 500,
          lineHeight: 20,
        },

        // formatter: function (val: string) {
        //   return numberWithCommas(parseInt(val));
        // },
      },
    },

    tooltip: {
      enabled: true,
      y: {
        formatter: function (val: any) {
          return val + 'K';
        },
      },
    },
  };
};

const options2 = (graphFilter: string) => {
  let categories: any[] = [];

  if (graphFilter === 'YEARLY') categories = months;
  else if (graphFilter === 'START_YEAR') categories = months.slice(0, new Date().getMonth() + 1);
  else if (graphFilter === 'HALF_YEARLY') {
    if (new Date().getMonth() <= 5) categories = months.slice(0, 6);
    else categories = months.slice(new Date().getMonth() - 5, new Date().getMonth() + 1);
  } else if (graphFilter === 'MONTHLY') categories = Array.from({ length: 31 }, (_, i) => i + 1);
  else if (graphFilter === 'WEEKLY') categories = Array.from({ length: 7 }, (_, i) => weekdays[i]);
  else categories = Array.from({ length: 24 }, (_, i) => i);

  return {
    legend: {
      show: false,
    },
    chart: {
      // type: 'bar',
      type: 'area',
      // height: 200,
      id: 'apexchart-example',

      toolbar: {
        show: false,
      },
    },
    dataLabels: {
      enabled: false,
      // hideOverflowingLabels: false,
    },

    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '55%',
        endingShape: 'rounded',
      },
    },

    stroke: {
      curve: 'smooth',
      width: 3,
      colors: ['#00ab47'],
      opacity: 0.6,
      // Using RGBA for semi-transparent blue
    },

    fill: {
      type: 'gradient',
      gradient: {
        type: 'vertical', // The gradient should be vertical, assuming the lighter color is at the bottom
        shadeIntensity: 1, // Intensity of the shade color
        opacityFrom: 0.7, // Full opacity at the start of the gradient
        opacityTo: 0.0, // Completely transparent at the end of the gradient
        stops: [0, 20, 40, 60, 80, 100], // More stops give a smoother gradient
        colorStops: [
          {
            offset: 0,
            color: '##00ab47',
            opacity: 0.09,
          },
          {
            offset: 20,
            color: '##00ab47',
            opacity: 0,
          },
          {
            offset: 40,
            color: '##00ab47',
            opacity: 0,
          },
          {
            offset: 60,
            color: '##00ab47',
            opacity: 0,
          },
          {
            offset: 80,
            color: '##00ab47',
            opacity: 0,
          },
          {
            offset: 100,
            color: '##00ab47',
            opacity: 0,
          },
        ],
      },
    },

    grid: {
      show: false,
    },
    xaxis: {
      categories: categories,
      axisTicks: {
        show: false,
      },

      tickAmount: 12,

      labels: {
        show: true,
        style: {
          colors: ['#00ab47'],
          fontSize: '13px',
          paddingRight: 15,
          paddingLeft: 15,
          fontFamily: 'Plus Jakarta Sans, Arial, sans-serif',
          fontWeight: 500,
          lineHeight: 20,
        },
      },
    },

    yaxis: {
      tickAmount: 12,
      labels: {
        show: false,
        style: {
          colors: ['#00ab47'],
          fontSize: '12px',
          paddingRight: 15,
          paddingLeft: 15,
          fontFamily: 'Plus Jakarta Sans, Arial, sans-serif',
          fontWeight: 500,
          lineHeight: 20,
        },

        // formatter: function (val: string) {
        //   return numberWithCommas(parseInt(val));
        // },
      },
    },

    markers: {
      size: 0,
      colors: ['#00ab47'], // Green color for the marker dot
      strokeColors: '#ffffff',
      strokeWidth: 2,
      show: false,
      hover: {
        size: 5, // The size of the marker when hovered
        sizeOffset: 3, // You can adjust this value if you want the marker to increase in size when hovered
      },
    },

    tooltip: {
      theme: 'light', // Choose between 'light' or 'dark'
      x: {
        show: false,
      },
      y: {
        formatter: function (val: number) {
          return '$ ' + val.toFixed(2);
        },
      },
      markers: {
        show: false,
      },
      custom: function ({
        series,
        seriesIndex,
        dataPointIndex,
        w,
      }: {
        series: number[][];
        seriesIndex: number;
        dataPointIndex: number;
        w: any;
      }) {
        const val = series[seriesIndex][dataPointIndex];

        return (
          '<div class="apexcharts-tooltip-title" style="font-weight: 600; color: #00ab47;">' +
          categories[dataPointIndex] +
          '</div><div class="apexcharts-tooltip-series-group" style="display: flex; align-items: center;">' +
          '<span class="apexcharts-tooltip-marker" style="background-color: #00ab47;"></span>' + // Green bullet point
          '<div class="apexcharts-tooltip-text" style="background-color: #f4f4f4; padding: 4px; border-radius: 2px;">' +
          '<span style="font-size: 12px; color: #333;">Total Log: $' +
          [val.toFixed(2)] +
          '</span>' +
          '</div></div>'
        );
      },
      fixed: {
        enabled: false,
      },
    },
  };
};

// const series = [
//   {
//     name: 'series-1',
//     data: [30, 40, 45, 40, 50, 49, 30, 40, 50],
//   },
// ];

interface GraphProps {
  data: {
    date: string;
    total_logs: number;
  }[];
  graphFilter: string;
  type: 'View' | 'Earning';
}

const Graph = (props: GraphProps) => {
  const { data, graphFilter, type } = props;
  const graphType = type;

  const graphData = data;

  const totalLogs =
    type === 'View'
      ? graphData.map((item) => item.total_logs)
      : graphData.map((item) => item.total_logs * 0.003);

  const chartData = {
    options: {
      chart: {
        type: 'area', // or 'bar', 'area', etc., depending on your needs
      },
      xaxis: {
        categories: months, // from the prepared data
      },
    },
    series: [
      {
        name: 'Total Log',
        data: totalLogs, // from the prepared data
      },
    ],
  };

  return (
    <div
      style={{
        width: '100%',
      }}
    >
      {!(chartData.series[0].data.length === 0) ? (
        <ReactApexChart
          type={'area'}
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          options={graphType === 'View' ? options(graphFilter) : options2(graphFilter)}
          series={chartData.series}
          height={306}
          width={'100%'}
          // key={graphFilter}
        />
      ) : (
        <Icons type={ICONS.NODATA} />
      )}
    </div>
  );
};

export default Graph;
